import { DeliverySummary } from "@/types/delivery"
import { TFunction } from "i18next"

const deviceVariations = ["Dock", "APBox", "Cell"]

function parseType(value: "D" | "R", t: TFunction<"", undefined>) {
  switch (value) {
    case "D":
      return t("dispatch")
    case "R":
      return t("return")
    default:
      return value
  }
}

function parseStatus(value: "C" | "D", t: TFunction<"", undefined>) {
  switch (value) {
    case "C":
      return t("closed")
    case "D":
      return t("shipped")
    default:
      return value
  }
}

function parseItem(row: unknown, t: TFunction<"", undefined>) {
  const summary = row as DeliverySummary

  return deviceVariations
    .reduce((result, device) => {
      const quantity = summary[`quantity${device}` as keyof DeliverySummary]

      if (quantity) {
        result.push(
          `${quantity} ${t(device === "APBox" ? "liveHubs" : `${device.toLowerCase()}s`)}`,
        )
      }

      return result
    }, [] as string[])
    .join(", ")
}

export default function useGetUtils() {
  return {
    parseItem,
    parseStatus,
    parseType,
  }
}
